import * as yup from 'yup';
import svStrings from '../../../sv-strings';
import { Field, FIELD_TYPES, OptionsGroup, UIschema } from '../../../types';
import { Announcement } from './types';

export const getAnnouncementSchema = (
  appConfigs: OptionsGroup[],
  announcement: Announcement
): UIschema => ({
  name: 'Edit announcement',
  fields: [
    {
      id: 'title',
      type: FIELD_TYPES.TEXT,
      key: 'title',
      value: announcement.title,
      title: svStrings.faq.fieldNameTitle,
      validation: yup.string().required(svStrings.announcements.titleFieldRequired),
    },
    {
      id: 'body',
      type: FIELD_TYPES.RICH_TEXT,
      key: 'body',
      value: announcement.body,
      title: svStrings.announcements.fieldNameBody,
    },
    {
      id: 'abbrv',
      type: FIELD_TYPES.SELECT,
      key: 'abbrv',
      value: announcement.abbrv,
      title: svStrings.announcements.fieldNameAbbrv,
      groupedOptions: [
        {
          name: 'all',
          options: ['all'],
          optionsText: [svStrings.announcements.all],
        },
        // ...appConfigs,
      ],
    },
    {
      id: 'scene',
      type: FIELD_TYPES.SELECT,
      key: 'scene',
      value: announcement.scene,
      title: svStrings.announcements.fieldNameScene,
      options: ['myPage', 'startPage'],
      optionsText: [svStrings.announcements.sceneMyPage, svStrings.announcements.sceneStartPage],
    },
    {
      id: 'type',
      type: FIELD_TYPES.SELECT,
      key: 'type',
      value: announcement.type,
      title: svStrings.announcements.fieldNameType,
      options: ['WARNING', 'INFO'],
      optionsText: [svStrings.announcements.optionWarning, svStrings.announcements.optionInfo],
      validation: yup.string().required(svStrings.announcements.typeFieldRequired),
    },
    {
      id: 'link',
      type: FIELD_TYPES.URL,
      key: 'link',
      value: announcement.link,
      title: svStrings.announcements.fieldNameLink,
      validation: yup.string().url(svStrings.validations.validUrl),
    },
    {
      id: 'linkText',
      type: FIELD_TYPES.TEXT,
      key: 'linkText',
      value: announcement.linkText,
      title: svStrings.announcements.fieldNameLinkText,
    },
  ] as Field[],
});
